export const columns = [
  { accessorKey: "paymentType", header: "Type of Payment", flex: 1 },
  { accessorKey: "paymentQuantity", header: "Quantity", flex: 1 },
  { accessorKey: "charges", header: "Total Charges", flex: 1 },
  {
    accessorKey: "actionButtons",
    header: "Action",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actionButtons || " "}`,
  },
];
